import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2px',
		width: '100%',
		minWidth: 0,
	},
	name: {
		fontSize: '12px',
		fontWeight: '600',
		lineHeight: 1.3,
	},
	meta: {
		fontSize: '11px',
		opacity: 0.75,
		lineHeight: 1.3,
	},
	distance: {
		fontWeight: '700',
		opacity: 1,
	},
}
